var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-toolbar',{attrs:{"flat":"","dense":""}},[_c('div',{staticClass:"subtitle-2"},[_vm._v("Hardware & Service Bills")]),(_vm.loading)?_c('v-progress-circular',{staticClass:"ml-2",attrs:{"indeterminate":"","size":"15","color":"secondary"}}):_vm._e()],1),_c('Table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }